<form [formGroup]="form" (ngSubmit)="model ? update() : create()">
    <div class="form-row mt-3">
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="telefono" class="form-control" 
                [placeholder]="'Ingrese teléfono (10 dígitos)'"
                [disabled]="model" maxlength="10">
            <label>Teléfono</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="primer_nombre" class="form-control"
                [placeholder]="'Ingrese primer nombre'">
            <label>Primer Nombre</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="segundo_nombre" class="form-control"
                [placeholder]="'Ingrese segundo nombre'">
            <label>Segundo Nombre</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="apellido_paterno" class="form-control"
                [placeholder]="'Ingrese apellido paterno'">
            <label>Apellido Paterno</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="apellido_materno" class="form-control"
                [placeholder]="'Ingrese apellido materno'">
            <label>Apellido Materno</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="calle" class="form-control"
                [placeholder]="'Ingrese calle'">
            <label>Calle</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="nombre_empresa" class="form-control"
                [placeholder]="'Ingrese nombre de empresa'">
            <label>Nombre de Empresa</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="numero_ext" class="form-control"
                [placeholder]="'Ingrese número exterior'">
            <label>N° Extensión</label>
        </div>
        <div class="form-field flex-grow-1">
            <select pInputText formControlName="boletinado" class="form-control">
                <option value="">Seleccione estado</option>
                <option *ngFor="let opcion of boletinadoOpciones" [value]="opcion.sOpcion">
                    {{ opcion.sOpcion }}
                </option>
            </select>
            <label>Boletinado</label>
        </div>
        <div class="form-field flex-grow-1">
            <select pInputText formControlName="tipoTelefono" class="form-control">
                <option value="">Seleccione tipo de teléfono</option>
                <option *ngFor="let opcion of tipoTelefonoOpciones" [value]="opcion.sOpcion">
                    {{ opcion.sOpcion }}
                </option>
            </select>
            <label>Tipo de Teléfono</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()">
            <mat-icon>tune</mat-icon>
            Customizables
        </button>
    </div>
</form>